
import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import useHtmlClass from '../../hooks/useHtmlClass';

const INIT_STATE = Map({
    trailerMovie: null,
    hasYoutubeCookieConfirmation: 'init'
})

function setTrailerMovie(state, action){
    const [addHtmlClass, removeHtmlClass] = useHtmlClass()
    if(action.payload.trailerMovie) {
        addHtmlClass('has-popup')
    } else {
        removeHtmlClass('has-popup')
    }

    return state.set('trailerMovie', action.payload.trailerMovie);
}

function setYoutubeCookieConfirmation(state, action){
    return state.set('hasYoutubeCookieConfirmation', action.payload.hasConfirmation);
}

export default function trailerReducer(state = INIT_STATE, action) {
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.UI_SET_TRAILER_MOVIE:
            return setTrailerMovie(state, action);
        case actionTypes.UI_SET_YOUTUBE_COOKIE_CONFIRMATION:
            return setYoutubeCookieConfirmation(state, action);
        default:
            return state;
    }
}